module.exports = "/_next/static/images/OneApi@2x-b91d84f35596949d2687727ba180f4b6.png";